import { useEffect, useState } from 'react';

const useDebounceValue = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return (): void => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounceValue;
